<template>
  <div>
    <v-alert type="info" variant="tonal" class="mb-3">
      <div>
        Сформований звіт можна завантажити протягом 24 годин. Звіт формується
        від <b>5 хв до 1 год</b> — залежно від розміру. Коли все буде готово, на
        бічній панелі зʼявиться значок.
      </div>
    </v-alert>

    <v-tabs density="comfortable" class="mb-3">
      <v-tab :to="{ name: 'report-printed-form-generate' }" replace>
        Доступні звіти
      </v-tab>
      <v-tab :to="{ name: 'report-printed-form-result' }" replace>
        Сформовані звіти
      </v-tab>
    </v-tabs>

    <router-view :printed-form-result="printedFormResult"></router-view>
  </div>
</template>

<script lang="ts">
import { reactive, watch } from 'vue'
import {
  PrintedFormResult,
  GeneratedPrintedForm,
  DebtorChronology,
} from '@/utils/types'
import { analyzeReportResult as analyzeReportResultRequest } from '@/request/report'
import {
  socket,
  reportAnalyzeChannel,
  reportFinancialAnalyzeChannel,
  reportDetailChannel,
  debtorDuplicateChannel,
  debtorChronologyChannel,
} from '@/socket'
import { useUser } from '@/store/user'
import { setSnackbar } from 'best-modules/plugins'

export default {
  name: 'Index',
  setup() {
    const { userData } = useUser()
    const printedFormResult = reactive<PrintedFormResult>({
      reportAnalyze: null,
      reportFinancialAnalyze: null,
      reportDetail: null,
      debtorDuplicate: null,
      debtorChronology: null,
    })
    const setReportProgress = (res: [PrintedFormResult] | []) => {
      if (res.length) {
        if (res[0].reportAnalyze?.userId === userData.id) {
          printedFormResult.reportAnalyze = res[0].reportAnalyze
        }
        if (res[0].reportFinancialAnalyze?.userId === userData.id) {
          printedFormResult.reportFinancialAnalyze =
            res[0].reportFinancialAnalyze
        }
        if (res[0].reportDetail?.userId === userData.id) {
          printedFormResult.reportDetail = res[0].reportDetail
        }
        if (res[0].debtorDuplicate?.userId === userData.id) {
          printedFormResult.debtorDuplicate = res[0].debtorDuplicate
        }
        if (res[0].debtorChronology?.userId === userData.id) {
          printedFormResult.debtorChronology = res[0].debtorChronology
        }
      }
    }

    const socketHandler = (
      socketRes: Pick<GeneratedPrintedForm, 'userId' | 'status'> | null
    ): boolean => {
      if (socketRes?.userId === userData.id) {
        if (socketRes.status === 'completed') {
          setSnackbar({
            text: 'Звіт сформовано, переглядайте в розділі "Сформовані звіти"',
          })
        }

        return true
      }

      return false
    }

    analyzeReportResultRequest().then(res => {
      setReportProgress(res)

      socket.on(
        reportAnalyzeChannel,
        (socketRes: GeneratedPrintedForm | null) => {
          if (socketHandler(socketRes)) {
            printedFormResult.reportAnalyze = socketRes
          }
        }
      )
      socket.on(
        reportFinancialAnalyzeChannel,
        (socketRes: GeneratedPrintedForm | null) => {
          if (socketHandler(socketRes)) {
            printedFormResult.reportFinancialAnalyze = socketRes
          }
        }
      )
      socket.on(
        reportDetailChannel,
        (socketRes: GeneratedPrintedForm | null) => {
          if (socketHandler(socketRes)) {
            printedFormResult.reportDetail = socketRes
          }
        }
      )
      socket.on(
        debtorDuplicateChannel,
        (socketRes: GeneratedPrintedForm | null) => {
          if (socketHandler(socketRes)) {
            printedFormResult.debtorDuplicate = socketRes
          }
        }
      )
      socket.on(
        debtorChronologyChannel,
        (socketRes: DebtorChronology | null) => {
          if (socketHandler(socketRes)) {
            printedFormResult.debtorChronology = socketRes
          }
        }
      )
    })

    watch(
      () => userData.watch_company_user_role?.companyId,
      () => {
        analyzeReportResultRequest().then(setReportProgress)
      }
    )

    return { printedFormResult }
  },
}
</script>

<style scoped lang="scss"></style>
